exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ConsultantSignUpForm-submit {\n  margin-top: 24px; }\n", ""]);

// exports
